import React, { useState, useEffect } from "react";
import {
  Modal,
  Typography,
  IconButton,
  Icon,
  Card,
  Tag,
  Dropdown,
  Radio,
  Button,
  Banner,
} from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import { StyledIcon } from "../Accounts/PlatformPreferences/Component/styled";
import profileService from "../../services/profileService";
import OtpInputFields from "../../components/OtpInputFields";
import MobileOtp from "./MobileOtp";
import AuthenticationSuccess from "../MFA/AuthenticationSuccess";
import { phone_codes } from "../../utils/locales";
import { PhoneNumberUtil } from "google-libphonenumber";
import { NotificationManager } from "react-notifications";
import SkipMFAConfirmation from "./SkipMFAConfirmation";

const StyledModal = styled(Modal).attrs()`
  background: ${(props) => props.theme.palette.background.tertiary};
`;
const StyledRadio = styled(Radio).attrs()`
  .eui-radio-icon {
    display: none;
  }
  .eui-radio-box {
    padding: 0px;
  }
`;
const TopPanel = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 67px;
  background: ${(props) => props.theme.palette.light.c100};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-shadow: inset 0px 0px 0px 1px rgba(0, 0, 0, 0.12);
`;

const StyledCard = styled(Card).attrs()`
  border: 1px solid
    ${(props) =>
      props.checked
        ? props.theme.palette.primary.c02
        : props.theme.palette.light.c300};
`;

const StyledAbsoluteDiv = styled.div`
  position: absolute;
  left: 181px;
  top: 68px;
  width: 57px;
  height: 57px;
  background: ${(props) => props.theme.palette.light.c000};
`;

const MFAModal = (props) => {
  const [selectedMFA, setSelectedMFA] = useState(1);
  const [qr, setQr] = useState("");
  const [qrLoading, setQrLoading] = useState(false);
  const [enableMobileMFALoading, setEnableMobileMFALoading] = useState(false);
  const [validateQrLoading, setValidateQrLoading] = useState(false);
  const [skipMFALoading, setSkipMFALoading] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [invalidOTPError, setInvalidOTPError] = useState("");
  const [mobileAuthenticationStep, setMobileAuthenticationStep] = useState("");
  const [isd_code_object, set_isd_code_object] = useState("+91");
  const [isd_code, set_isd_code] = useState("");
  const [phone_codes_ui, set_phone_codes_ui] = useState("");
  const [phnNumber, setPhnNumner] = useState("");
  const [invalidOtpMsg, setInvalidOtpMsg] = useState(false);
  const [showResendMsg, setShowResendMsg] = useState(true);
  const [phnNumError, setPhnNumError] = useState(false);
  const [step, setStep] = useState(1);
  const [renderTurnstileCaptcha, setRenderTurnstileCaptcha] = useState(false);
  const [renderResendTurnstileCaptcha, setRenderResentTurnstileCaptcha] =
    useState(false);
  const [otp_id, set_otp_id] = useState("");
  const [otpAutoFocusTrigger, setOtpAutoFocusTrigger] = useState("");
  const [showOtpLoading, setShwoOtpLoading] = useState(false);
  const [authenticationDone, setAuthnticationDone] = useState(0);
  const [showQrCode, setShowQrCode] = useState(0);
  const [skipMFAModal, setSkipMFAModal] = useState(false);

  const showCts = false;
  const phoneUtil = PhoneNumberUtil.getInstance();

  const handleValidateOtp = () => {
    registerAuthAppQRCode(otpValue);
  };
  const getDefaultIsd = (phone_codes_ui) => {
    profileService.fetchCountryBasedonIP().then((response) => {
      if (response && response.plumApi && response.plumApi.output) {
        const ipBasedOutput = JSON.parse(response.plumApi.output);
        let countryCode = "IN";
        if (ipBasedOutput.success && ipBasedOutput.success === 1) {
          countryCode = ipBasedOutput.country_code;
        }
        const phonecodeDetails = phone_codes_ui.find(
          (item) => item.iso == countryCode
        );
        set_isd_code_object(phonecodeDetails);
      }
    });
  };

  const handleMobileChange = (event) => {
    if (event && event.target) {
      let phnNum = event.target.value;

      if (
        !(phnNum.length == 0 && phnNum == "") &&
        !/^[1-9][\d]{0,15}$/gm.test(phnNum)
      ) {
        return;
      }
      setPhnNumError(false);
      setPhnNumner(phnNum ? phnNum : "");
    }
  };

  useEffect(() => {
    const employee_primary_mobile =
      props.accountReducer?.employeeDetails?.employee_primary_mobile;
    const splitNum = employee_primary_mobile?.split("-");
    const employeePhnNum = splitNum?.length > 1 ? splitNum?.[1] : "";
    const employeePhnCode = splitNum?.length ? splitNum?.[0] : "";

    const phone_codes_ui =
      phone_codes &&
      phone_codes.map((item) => {
        let obj = item;
        obj.label = item.iso + " " + item.phonecode;
        obj.value = item.country_id;
        return obj;
      });
    const phoneCodeDetails = phone_codes_ui.find(
      (item) => item.phonecode == employeePhnCode
    );
    setPhnNumner(employeePhnNum);
    set_phone_codes_ui(phone_codes_ui);
    phoneCodeDetails
      ? set_isd_code_object(phoneCodeDetails)
      : getDefaultIsd(phone_codes_ui);
    employeePhnNum && setStep(2);
  }, []);

  useEffect(() => {
    const employee_primary_mobile =
      props.accountReducer?.employeeDetails?.employee_primary_mobile;
    const splitNum = employee_primary_mobile?.split("-");
    const employeePhnNum = splitNum?.length > 1 ? splitNum?.[1] : "";
    mobileAuthenticationStep &&
      selectedMFA === 2 &&
      step === 2 &&
      employeePhnNum &&
      enableMobileMFA(1);
  }, [
    props.accountReducer?.employeeDetails?.employee_primary_mobile,
    mobileAuthenticationStep,
  ]);

  useEffect(() => {
    !mobileAuthenticationStep && otpValue?.length === 6 && handleValidateOtp();
  }, [otpValue]);
  const mfaModes = [
    {
      id: 1,
      title: (
        <div className="d-flex flex-column">
          <div className="d-flex flex-row align-items-center">
            <StyledIcon
              iconName="PlumAuthenticator"
              size={20}
              color="dark"
              shade="c200"
            />
            <Tag
              variant="status"
              color="success"
              label="Recommended"
              mr={2}
              className="ml-auto"
            />
          </div>

          <Typography.ButtonText
            component="span"
            color={selectedMFA === 1 ? "primary" : "dark"}
            shade={selectedMFA === 1 ? "c02" : "c300"}
            className="mt-12"
          >
            Verify using Authenticator App
          </Typography.ButtonText>
          <Typography.HelperText
            color="dark"
            shade="c200"
            className="offline-transfers mt-4"
          >
            Scan QR code through your authenticator app and confirm your
            authenticity.
          </Typography.HelperText>
        </div>
      ),
      description: {
        message: "",
      },

      value: 1,
      show: true,
      message: "",
    },
    {
      id: 2,
      title: (
        <div className="d-flex flex-column">
          <StyledIcon
            iconName="PlumSmartphone"
            size={20}
            color="dark"
            shade="c200"
          />
          <Typography.ButtonText
            component="span"
            color={selectedMFA === 2 ? "primary" : "dark"}
            shade={selectedMFA === 2 ? "c02" : "c300"}
            className="mt-12"
          >
            Verify using Mobile Number
          </Typography.ButtonText>
          <Typography.HelperText
            color="dark"
            shade="c200"
            className="offline-transfers mt-4"
          >
            We'll send an OTP to verify your mobile number and confirm your
            authenticity.
          </Typography.HelperText>
        </div>
      ),
      description: {
        message: "",
      },

      value: 2,
      show: true,
      message: "",
    },
  ];
  const onClose = () => {
    fetchAndUpdateMFAData();
    props.updateMFAData({ ...props.mfaData, showMFAModal: false });
  };

  const handleChange = (mfaMode) => {
    setSelectedMFA(mfaMode);
  };
  const generateAuthAppQRCode = async () => {
    setQrLoading(true);
    const qrData = await profileService.generateAuthAppQRCode();
    if (qrData?.generateAuthAppCode?.image) {
      setQr(qrData?.generateAuthAppCode?.image);
    } else {
      NotificationManager.error("Something went wrong. Try again later.");
      props.updateMFAData({ ...props.mfaData, showMFAModal: false });
    }

    setQrLoading(false);
  };
  const enableMobileMFA = async (action_type = 1) => {
    setEnableMobileMFALoading(true);
    const phone = `${isd_code_object.phonecode}-${phnNumber}`;
    const mobileMFAOtp = await profileService.enableMobileMFA({
      mfa_mobile: phone,
      action_type: action_type,
      otp: otpValue,
    });
    setEnableMobileMFALoading(false);
    setRenderTurnstileCaptcha(false);
    setRenderResentTurnstileCaptcha(false);
    if (mobileMFAOtp?.enableMobileMFA?.success) {
      if (action_type === 2) {
        setAuthnticationDone(2);
      }
      setStep(2);
    } else {
      setInvalidOtpMsg(true);
      if (
        mobileMFAOtp?.errors?.[0]?.message === "auth.request_limit_exceeded" ||
        mobileMFAOtp?.status === 429
      ) {
        setInvalidOTPError(
          "Limit exceeded, please try again in sometime. If it reoccurs, please reach out to cs@giift.com. Thank you for your patience."
        );
      } else {
        setInvalidOTPError(
          "Invalid Otp. Please check your code and try again."
        );
      }
    }
    set_otp_id(true);
    //setLoadingfalse
  };
  const registerAuthAppQRCode = async () => {
    setValidateQrLoading(true);
    const authAppCode = await profileService.registerAuthAppCode(otpValue);
    if (authAppCode?.registerAuthAppCodeAdmin?.success) {
      setAuthnticationDone(1);
    } else {
      setInvalidOTPError("Enter the correct confirmation code.");
      setInvalidOtpMsg(true);
    }

    setValidateQrLoading(false);
  };
  const skipMFA = async () => {
    props.updateMFAData({ ...props.mfaData, showMFAModal: false });
    setSkipMFALoading(true);
    await profileService.skipMFA();
    await fetchAndUpdateMFAData();
    setSkipMFALoading(false);
  };
  const fetchAndUpdateMFAData = async () => {
    const MFAData = await profileService.fetchMFAData();
    props.updateMFAData({ res: MFAData?.fetchMFADetails?.res || [] });
  };
  const handleSendOtp = (event) => {
    event.preventDefault();
    if (
      !phoneUtil.isValidNumberForRegion(
        phoneUtil.parse(
          `${isd_code_object.phonecode}${phnNumber.trim()}`,
          `${isd_code_object.iso}`
        ),
        `${isd_code_object.iso}`
      )
    ) {
      setPhnNumError(true);
      setRenderTurnstileCaptcha(false);
      setRenderResentTurnstileCaptcha(false);
      return;
    }
    //setLoader
    // if (this.state.otp_id) return this.proceedToPayment;

    // this.proceedToPayment();
    if (showCts) {
      setRenderTurnstileCaptcha(true);
    } else {
      enableMobileMFA();
    }
  };

  const handleISDchange = (event) => {
    set_isd_code_object(event);
    set_isd_code(event.phonecode);
  };

  const MFAModeSelection = (
    <>
      <Typography color="dark" shade="c200">
        Choose an option to enhance your account security with two-step
        authentication
      </Typography>
      <Banner
        color="info"
        iconName=""
        description={
          <div className="d-flex">
            <Icon
              iconName="PlumMessage"
              size={20}
              className="mr-18 px-4"
              color="dark"
              shade="c200"
            />
            <Typography.LabelText color="dark" shade="c200" className="d-flex">
              Your current authentication method is{" "}
              <Typography.LabelText color="dark" shade="c300" className="ml-3">
                Email
              </Typography.LabelText>
              .
            </Typography.LabelText>
          </div>
        }
        className="pl-26"
      />
      {mfaModes.map((mode, index) => {
        return (
          <StyledCard
            key={mode.id}
            className={`paymentMethod ${"mt-24"} p-16`}
            spaceAround={6}
            shadow={false}
            checked={selectedMFA === mode.value}
          >
            <StyledRadio
              checked={selectedMFA === mode.value}
              onChange={(e) => {
                handleChange(mode.value);
              }}
              value={mode.value}
              label={mode.title}
              description={mode.subTitle}
              disabled={mode.show === false}
            />
            <div className="ml-2">
              <div className="ml-40">
                {mode?.description?.message ? mode?.description.message : ""}
              </div>
              <div>{mode.message}</div>
            </div>
            {mode.description ? (
              <>
                <div className="ml-2 offline_payment mr-36 ml-26">
                  <div className="title inkLight">{mode.description.title}</div>
                  {mode.description.list}
                </div>
              </>
            ) : null}
            {/* {!mode.show && (
      <Banner
        iconName=""
        color="error"
        description="This payment mode is not recommended while sending reward."
        className="py-8"
      />
    )} */}
          </StyledCard>
        );
      })}
    </>
  );
  const qrImage = (
    <div className="d-flex flex-column justify-content-center">
      <img src={qr} alt={"QR Code"} width="208px" />
      <Button
        variant="plain"
        onClick={() => setShowQrCode(false)}
        className="cursor-pointer p-0"
      >
        Hide QR Code
      </Button>
    </div>
  );
  const hiddenQrImage = (
    <div className="d-flex flex-column justify-content-center">
      <div
        style={{
          width: "208px",
          height: "208px",
          opacity: ".01",
        }}
      >
        <StyledAbsoluteDiv></StyledAbsoluteDiv>
        <img src={qr} alt={"QR Code"} />
      </div>
      <Button
        variant="plain"
        onClick={() => setShowQrCode(true)}
        className="cursor-pointer p-0"
      >
        Show QR Code
      </Button>
    </div>
  );

  const handleOtpInput = (otp) => {
    setOtpValue(otp);
  };

  const qrCodeStep = (
    <div>
      <Typography.ButtonText color="dark" shade="c300">
        Scan the QR Code using your Authenticator App
      </Typography.ButtonText>
      <Typography.HelperText color="dark" shade="c200" className="mt-4">
        Download any authenticator app such as Google Authenticator or Microsoft
        Authenticator and scan the QR code to setup account.
      </Typography.HelperText>
      <div className="d-flex flex-column align-items-center mt-20 position-relative">
        {!showQrCode ? hiddenQrImage : qrImage}
      </div>
      <hr className="my-20" />
      <Typography.ButtonText color="dark" shade="c300">
        Enter Authentication Code
      </Typography.ButtonText>
      <Typography.HelperText color="dark" shade="c200" className="mt-4">
        Enter the 6-digit code from your authenticator app after setup.
      </Typography.HelperText>
      <div style={{ gap: "19px" }} className="mt-20">
        <OtpInputFields
          onComplete={(data) => handleOtpInput(data)}
          otp={otpValue}
          otpAutoFocusTrigger={props.otpAutoFocusTrigger}
          triggerFocus={() => props.triggerFocus(!props.otpAutoFocusTrigger)}
          className="my-16"
          error={invalidOTPError}
        />
        {invalidOTPError ? (
          <Typography.HelperText color="red" shade="c300">
            Enter the correct authentication code.
          </Typography.HelperText>
        ) : null}
      </div>
    </div>
  );

  return (
    <StyledModal isOpen={props.showMFAModal} fullScreen padding={false}>
      <div className="d-flex justify-content-center">
        <Card
          className="mt-100 p-28 d-flex flex-column"
          style={{ width: "476px" }}
        >
          {skipMFAModal ? (
            <SkipMFAConfirmation
              skipMFA={skipMFA}
              goBack={() => {
                setSkipMFAModal(false);
              }}
            />
          ) : authenticationDone ? (
            <AuthenticationSuccess
              type={authenticationDone}
              onClose={onClose}
              phnNumber={`${isd_code_object?.phonecode}-${phnNumber}`}
            />
          ) : mobileAuthenticationStep ? (
            <MobileOtp
              showCts={false}
              showOtpModal={mobileAuthenticationStep}
              updateOtp={(otp) => {
                setOtpValue(otp);
                setInvalidOtpMsg(false);
                setShowResendMsg(false);
              }}
              otpValue={otpValue}
              isd_code_object={isd_code_object}
              validateOtp={() => enableMobileMFA(2)}
              resendOtp={() => enableMobileMFA(1)}
              otp_id={otp_id}
              phnNumber={phnNumber}
              showResendMsg={showResendMsg}
              invalidOtpMsg={invalidOtpMsg}
              otpAutoFocusTrigger={otpAutoFocusTrigger}
              showOtpLoading={showOtpLoading}
              triggerFocus={(data) => setOtpAutoFocusTrigger(data)}
              handleSendOtp={handleSendOtp}
              handleISDchange={handleISDchange}
              handleMobileChange={handleMobileChange}
              phone_codes_ui={phone_codes_ui}
              phnNumError={phnNumError}
              accountReducer={props.accountReducer}
              step={step}
              setStep={setStep}
              handleGenerateRechargeOtp={() => enableMobileMFA()}
              disableCloseButton={false}
              setMobileAuthenticationStep={setMobileAuthenticationStep}
              renderTurnstileCaptcha={renderTurnstileCaptcha}
              renderResendTurnstileCaptcha={renderResendTurnstileCaptcha}
              enableMobileMFALoading={enableMobileMFALoading}
            />
          ) : qr ? (
            qrCodeStep
          ) : (
            MFAModeSelection
          )}

          {!skipMFAModal && !mobileAuthenticationStep && !authenticationDone && (
            <div className="d-flex flex-row ml-auto mt-32">
              {selectedMFA == 1 && qr ? (
                <Button variant="plain" onClick={() => setQr("")}>
                  Back
                </Button>
              ) : !(
                  props.mfaData?.res?.length &&
                  props.mfaData?.res?.[0]?.skip_mfa
                ) ? (
                <Button
                  variant="plain"
                  onClick={() => setSkipMFAModal(true)}
                  loading={skipMFALoading}
                  disabled={skipMFALoading}
                >
                  Skip For Now
                </Button>
              ) : null}
              <Button
                className="ml-12"
                onClick={() => {
                  if (selectedMFA == 1 && qr) handleValidateOtp();
                  else if (selectedMFA == 1) generateAuthAppQRCode();
                  else setMobileAuthenticationStep(true);
                }}
                loading={qrLoading || validateQrLoading}
                disabled={qrLoading || validateQrLoading}
              >
                Continue
              </Button>
            </div>
          )}
        </Card>
      </div>
      <TopPanel className="d-flex justify-content-between">
        <Typography.H3 className="ml-40" color="dark" shade="c300">
          Set Two-Step Authentication
        </Typography.H3>
        {props.mfaData?.res?.length &&
        props.mfaData?.res?.[0]?.skip_mfa == 1 ? (
          <IconButton
            variant="plain"
            size={20}
            onClick={() => {
              skipMFA();
            }}
            className="mr-40"
          >
            <Icon iconName="Close" color="text" shade="c01" size={16} />
          </IconButton>
        ) : null}
      </TopPanel>
    </StyledModal>
  );
};

export default MFAModal;
